// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

// Components
import { Trans, FormActions, FormActionsItem } from '../../../components';
import { TxButton, TxButtonMode } from 'texkit-ui';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import SummaryCard from 'texkit/dist/components/Cards/SummaryCard/SummaryCard';

// Helpers
import { toSentenceCase } from '../../../lib/helpers';

const TXRCAlreadyLinkedSummary = (account) => {
  const dispatch = useDispatch();

  const items = ["name", "licenseNumber", "licenseType"].map((identifier, idx) => {
                    const value = account[identifier];
                    if (!value) return null;
                    return {
                     className: 'word-break',
                     label: <Trans file="Labels" id={`txrc_${identifier}`} />,
                     value: value || 'N/A',
   }});

  return (
    <>
      <h1 className="h2">
        <Trans
          file="txrc"
          id="txrclicenserenewal_LinkService_ConfirmTitleLinked"
        />
      </h1>
      <p>
        <Trans
          file="txrc"
          id="txrclicenserenewal_LinkService_ConfirmDescriptionLinked"
        />
      </p>
        <SummaryCard>
          <SummaryCard.List
            items={items}
          />
        </SummaryCard>
      <FormActions>
        <FormActionsItem>
          <ButtonPrimary onClick={() => dispatch(push(`/agency/txrc`))}>
            <Trans
              file="txrc"
              id="txrclicenserenewal_ViewItem"
            />
          </ButtonPrimary>
        </FormActionsItem>
        <FormActionsItem>
          <TxButton
            mode={TxButtonMode.Secondary}
            onClick={() => dispatch(push(`/link/lookup/txrclicenserenewal`))}
          >
            <Trans file="txrc" id={`txrclicenserenewal_LinkDifferent`} />
          </TxButton>
        </FormActionsItem>
      </FormActions>
    </>
  );
};

TXRCAlreadyLinkedSummary.propTypes = {
   account: PropTypes.object.isRequired
};

export default TXRCAlreadyLinkedSummary;
